<template>
    <v-dialog
        v-model="$store.state.newTransact.NoRate"
        transition="dialog-transition"
    >
        <v-card>
                <v-toolbar color="primary" dense dark>
                    <v-spacer></v-spacer>
                        <v-toolbar-title>
                            No Rates Report
                        </v-toolbar-title>
                    <v-spacer></v-spacer>
                    <v-btn  @click="$store.state.newTransact.NoRate = false;"
                    icon>
                    <v-icon>mdi-close</v-icon></v-btn>
                </v-toolbar>
                <v-container grid-list-xs fluid>
                    <v-row justify="end">
                        <v-col cols="1"><v-btn color="success" icon @click="getNoRateLoads"><v-icon>mdi-microsoft-excel</v-icon></v-btn></v-col>
                    </v-row>
                    <v-data-table
                        :headers="headers"
                        :items="orders"
                        class="elevation-1"
                        dense
                    >                        
                    </v-data-table>
                </v-container>
        </v-card>
    </v-dialog>
</template>

<script>
// import moment from 'moment';
import axios from 'axios';
export default {
    props: ['orders'],
    data: function() {
        return {
            headers:[
                { text: 'OrderID', value: 'OrderID', width: '10%' },
                { text: 'ShiftDetail', value: 'ShiftDetail', width: '10%' },
                { text: 'Customer', value: 'Customer', width: '10%' },
                { text: 'Terminal', value: 'Terminal', width: '10%' },
                { text: 'Address', value: 'TrmAddress', width: '10%' },
                { text: 'City', value: 'TrmCity', width: '10%' },
                { text: 'Station', value: 'Station', width: '10%' },
                { text: 'Address', value: 'StAddress', width: '10%' },
                { text: 'City', value: 'StCity', width: '10%' },
                { text: 'GasRate', value: 'GasRate', width: '10%' },
                { text: 'DiesRate', value: 'DiesRate', width: '10%' },
                { text: 'InvFlat', value: 'InvFlat', width: '10%' }, 
                { text: 'PayDiesel', value: 'OOByLitreDiesel', width: '10%' },   
                { text: 'PayGas', value: 'OOByLitre', width: '10%' },   
            ]
        };
    },
    mounted() {
        console.log(this.orders);
    },
    methods: {
        getNoRateLoads: function(){
            var str = this.$store;
            // str.state.isLoading = true;
            var parms = {
                StartDate: this.$store.state.getMsk('StartDate'),
                EndDate: this.$store.state.getMsk('EndDate'),
                Export:1
            };
            axios
                .post('new-transaction/no-rate/load', parms,{
                    responseType: 'blob',
                    headers: {
                        Authorization: 'Bearer ' + this.$store.state.token
                    }
                })
                .then(response => {
                    console.log(response.data);
                    const url = window.URL.createObjectURL(
                        new Blob([response.data])
                    );
                    const link = document.createElement('a');
                    link.href = url;
                    link.setAttribute(
                        'download', "No Rate Report.xlsx"
                    );
                    document.body.appendChild(link);
                    link.click();

                    str.state.isLoading = false;
                })
                .catch(function (error) {
                    console.log(error);
                    if (error.response.status === 403) {
                        str.dispatch('setSnackbar', {
                            color: 'error',
                            text:
                                'You do not have the permission to use this function.'
                        });
                    }
                });
        },
    }
};
</script>

<style></style>
